// extracted by mini-css-extract-plugin
export default {"bgWrapper":"ReportBody_bgWrapper__4E5I4"};